import React from 'react';
import "./amazonaccountmgt.css";
import Experience from "../domestic-services/experiencecount"
import Testimonial from '../components/testimonial';

const Events = () => {
    return (
        <>

  
         <div className="col-sm color-slider-section text-center">
  {/* Background Video */}
  <video
    className="bg-video"
    autoPlay
    muted
    loop
    playsInline
  >
    <source src={require("../components/videos/bg33.mp4")} type="video/mp4" />
  </video>

  {/* Overlay Content */}
  <div className="color-slider-content">
    <h2 className="p-2">Amazon Account Management Services</h2>

    <p>
      E Seller Support provides structured and reliable Amazon Account Management services to help sellers streamline their operations and scale effectively.
    </p>

    <p>
      With a process-driven approach and an experienced team, we ensure policy compliance and end-to-end support across Amazon marketplaces.
    </p>

    {/* Buttons */}
    <div className="mt-4 d-flex gap-3 flex-wrap justify-content-center">
      <a href="tel:+918527203697" className="btn btn-warning px-4 py-2">
        Call Us +91 85272 03697
      </a>
      <a href="/Contact" className="btn btn-outline-light px-4 py-2">
        Enquiry
      </a>
    </div>
  </div>
</div>

     <div className='bg'>           
   <div className="row g-3">
  
<h3 className="h33">
  Our Account Management Service
</h3>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Product Listing Optimization</h6>
      <p>We create and optimize Amazon product listings using accurate content, relevant keywords, and platform-compliant formats to improve product visibility and listing quality.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Brand Approval Assistance</h6>
      <p>Our team guides sellers through brand approval requirements by preparing and submitting necessary documentation accurately.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Account Health Monitoring</h6>
      <p>We monitor key Amazon account health metrics and notifications to help sellers stay compliant and reduce the risk of policy issues.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Policy Compliance & Risk Prevention</h6>
      <p>We identify potential policy risks and assist sellers in taking corrective actions to reduce the chances of account warnings or suspensions.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>FBA & FBM Operations Guidance</h6>
      <p>We assist sellers with FBA and FBM operational processes, including shipment creation support and order workflow guidance.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Order & Performance Monitoring</h6>
      <p>We track order-related issues, customer metrics, and performance notifications to ensure smooth fulfilment operations.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Payment & Settlement Review Support</h6>
      <p>We help sellers review settlement reports and payment-related data for better financial tracking and clarity.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Advertising Campaign Management</h6>
      <p>Our team plans and manages Amazon advertising campaigns with a structured approach to improve reach, control spend, and support overall account performance.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Safety Claim & Compliance Support</h6>
      <p> We work closely with sellers to ensure that safety claims, certifications, and compliance information are submitted accurately and in line with Amazon Seller Central policies.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Payment & Settlement Review Support</h6>
      <p>We assist sellers in reviewing settlement reports, transaction summaries, and payment-related data to ensure better financial visibility and clarity.</p>
    </div>
  </div>
</div>
   
  
 <div className="h34">
    <h2 className="p-2">How We Work – Our Account Management Process</h2>
    <p>
     At E Seller Support, we follow a structured, process-driven approach to manage Amazon seller accounts.</p>
    <p>  Our focus is on compliance, efficiency, and transparent communication to ensure sellers can operate smoothly and maintain account health.
    </p>
  </div>


<div className="row g-3">
  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Dedicated Account Manager</h6>
      <p>Each seller is assigned a trained account manager who acts as the main point of contact. This ensures personalized support, timely updates, and consistent oversight of all account operations.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Regular Account Audits</h6>
      <p>We conduct periodic audits of the seller account to monitor listing quality, catalog accuracy, and compliance with Amazon policies. These audits help identify potential risks before they impact account performance.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Proactive Issue Identification & Resolution</h6>
      <p>Our team actively monitors notifications, performance metrics, and account health alerts to identify issues early. We then assist sellers in addressing these issues promptly, following Amazon’s recommended guidelines.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Transparent Communication with Sellers</h6>
      <p>We maintain clear and structured communication with our sellers, providing updates, reports, and recommendations. This ensures sellers are aware of all actions taken on their account and can make informed decisions.</p>
    </div>
  </div>

  <div className="col-12 col-md-4 col-lg-3">
    <div className="service-box">
      <h6>Data-Driven Account Improvement</h6>
      <p>We use data from account performance, order metrics, and operational reports to suggest improvements, optimize processes, and guide sellers toward maintaining a compliant and stable account.</p>
    </div>
  </div>
</div>
<div className="white-section text-center">
     <div className="row align-items-center justify-content-center g-4">

    <div className="col-12 col-md-6">
      <div className="color-slider-content1 d-flex flex-column align-items-center"> <h3>“Who We Serve”</h3>

        <h5>E Seller Support works with:</h5>
        <ul className="custom-bullet-list animated-bullets text-start d-inline-block"> 
          <li>New Amazon sellers starting their journey</li>
          <li>Existing sellers looking to stabilize and optimize operations</li>
          <li>Domestic sellers operating on Amazon India marketplaces</li>
        </ul>

        <p className="mt-3">
          Our services are designed to support sellers who require structured
          account management, compliance assistance, and operational coordination.
        </p>
      </div>
    </div>

    <div className="col-12 col-md-6">
      <div className="color-slider-content1 d-flex flex-column align-items-center"> <h3>“Why Choose E Seller Support”</h3>
        <ul className="custom-bullet-list animated-bullets text-start d-inline-block">
          <li>Dedicated account manager for each seller</li>
          <li>Compliance-first operational support</li>
          <li>Transparent communication and reporting</li>
          <li>Structured monitoring of account health and performance</li>
          <li>Support aligned with Amazon Seller Central policies</li>
        </ul>
        <p className="mt-3">⚠️ NO sales guarantee, NO approval promise — good for SPN.</p>
      </div>
    </div>

  </div>
</div>
<Experience/>
<Testimonial/>

<div className="h35">
 <h3>Disclaimer</h3>
<p style={{ fontStyle: "italic" }}>
  All services are provided in accordance with Amazon Seller Central policies and guidelines.
  We do not offer any services that violate Amazon’s terms or policies.
</p>
</div>
</div>          
        </>
    );
};

export default Events;
